import { subFeaturesGeneralSettings, subFeaturesModuleSettings, tabNames, userActions } from '@va/constants';
import { isWixWebsite, websiteRoleSelectors } from '@va/dashboard/selectors/core';
import { getActiveTab } from '@va/dashboard/selectors/ui';
import { UserRole } from '@va/types/website';

export const selectHasPermission = (state: any, action: string, subFeature?: string, tabName?: string) => {
  const currentUserRole = websiteRoleSelectors.selectWebsiteRole(state);

  const isWix = isWixWebsite(state);
  const activeTab = getActiveTab(state);
  const tab = tabName ?? activeTab;

  if (isWix) return true;

  if (currentUserRole === UserRole.EDITOR) {
    switch (tab) {
      case tabNames.funnels:
        return [userActions.Create, userActions.Edit, userActions.Delete].includes(action);
      case tabNames.pageSettings:
      case tabNames.conversionEvents:
      case tabNames.conversionsSettings:
      case tabNames.conversions:
        return [userActions.Create, userActions.Edit, userActions.Delete, userActions.Settings].includes(action);
      case tabNames.recordingsDetailsPage:
      case tabNames.recordings:
        return [
          userActions.Create,
          userActions.Edit,
          userActions.Delete,
          userActions.Settings,
          userActions.ChangeStatus,
        ].includes(action);
      case tabNames.generalSettings:
        return getGeneralSettingsPermission(subFeature ?? '', action);
      case tabNames.heatmaps:
        return [
          userActions.Create,
          userActions.Edit,
          userActions.Delete,
          userActions.ChangeStatus,
          userActions.Reset,
          userActions.Settings,
        ].includes(action);
      case tabNames.polls:
      case tabNames.surveys:
        return [userActions.Create, userActions.Edit, userActions.Delete, userActions.ChangeStatus].includes(action);
      case tabNames.eventTracking:
        return [
          userActions.Enable,
          userActions.Create,
          userActions.ChangeStatus,
          userActions.Edit,
          userActions.Delete,
        ].includes(action);
      case tabNames.overview:
        return [userActions.ChangeStatus, userActions.Create].includes(action);
      case tabNames.trendIntel:
        return [userActions.Create, userActions.Edit, userActions.Delete, userActions.ChangeStatus].includes(action);
      case tabNames.modulesSettings:
        return getModuleSettingsPermission(subFeature ?? '', action);
      default:
        return false;
    }
  } else if (currentUserRole === UserRole.DASHBOARD) {
    //TODO - update the permissions
    return false;
  } else if (currentUserRole === UserRole.WATCHER) {
    return false;
  } else {
    return true;
  }
};

const getGeneralSettingsPermission = (subFeature: string, action: string) => {
  switch (subFeature) {
    case subFeaturesGeneralSettings.ignoreSelfVisits:
    case subFeaturesGeneralSettings.whiteListDomain:
      return [userActions.Create, userActions.Delete].includes(action);
    default:
      return false;
  }
};

const getModuleSettingsPermission = (subFeature: string, action: string) => {
  switch (subFeature) {
    case subFeaturesModuleSettings.eventTracking:
      return [userActions.Settings].includes(action);
    case subFeaturesModuleSettings.sessionRecordings:
      return [userActions.Settings].includes(action);
    case subFeaturesModuleSettings.ecommerce:
    case subFeaturesModuleSettings.outgoingTrafic:
      return false;
    case subFeaturesModuleSettings.conversionEvents:
      return [userActions.Create, userActions.Edit, userActions.Delete].includes(action);
    default:
      return false;
  }
};
